import { apiClient } from './api';

export interface SearchResult {
  entity_id: string;
  content: string;
  metadata: {
    name?: string;
    name_ui?: string;
    [key: string]: any;
  };
  similarity: number;
}

export const searchService = {
  searchSpecies: async (query: string, limit: number = 5): Promise<SearchResult[]> => {
    return apiClient.get<SearchResult[]>(
      `/search/species?q=${encodeURIComponent(query)}&limit=${limit}`,
    );
  },

  searchPests: async (query: string, limit: number = 5): Promise<SearchResult[]> => {
    return apiClient.get<SearchResult[]>(
      `/search/pests?q=${encodeURIComponent(query)}&limit=${limit}`,
    );
  },

  searchDiseases: async (query: string, limit: number = 5): Promise<SearchResult[]> => {
    return apiClient.get<SearchResult[]>(
      `/search/diseases?q=${encodeURIComponent(query)}&limit=${limit}`,
    );
  },

  // Generic search for species, pests, and diseases
  searchAll: async (
    query: string,
    limit: number = 3,
  ): Promise<{
    species: SearchResult[];
    pests: SearchResult[];
    diseases: SearchResult[];
  }> => {
    const [species, pests, diseases] = await Promise.all([
      searchService.searchSpecies(query, limit),
      searchService.searchPests(query, limit),
      searchService.searchDiseases(query, limit),
    ]);

    return { species, pests, diseases };
  },
};
